export const ORGANIZATION_CATEGORY_STORE = 'ORGANIZATION_CATEGORY_STORE';
export const ORGANIZATION_CATEGORY_UPDATE = 'ORGANIZATION_CATEGORY_UPDATE';
export const ORGANIZATION_CATEGORY_DESTROY = 'ORGANIZATION_CATEGORY_DESTROY';
